import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {FaqComponent} from './faq.component';


const routes: Routes = [
  // {
  //   path: ':slug',
  //   component: FaqComponent,
  // },
  {
    path: '**',
    component: FaqComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FaqRoutingModule {}